/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { useIntl } from "react-intl";
import {PageLink, PageTitle, PageToolbar} from "../../components/layout/core";
import Components from "../../components";
import {KTIcon} from "../../../_metronic/helpers";
import {useQuery} from "react-query";
import {getTeacherAppeal, getTeacherReport} from "../../api/_requests";
import {URL_TEACHER_MAIN_NEW_ABOUT, URL_TEACHER_REPORTS_NEW} from "../../mock/page_urls";
import {useNavigate} from "react-router-dom";

const reportsBreadCrumbs: Array<PageLink> = [
  {
    title: "Shikoyatlar",
    path: "/",
    isSeparator: false,
    isActive: false,
  },
];

const header = [
  { label: "№" },
  { label: "Mavzusi" },
  { label: "Shikoyat matni" },
  { label: "Javob berilganmi" },
  { label: "O'quv yili" },
  { label: "Yaratilgan sana" },
  { label: "Kerakli" },
];


const bodyKey = [
  "id",
  "title",
  "message",
  "status",
  "academic_year",
  "created_at",
];

const teacherReports = {
  results: [
    {
      message: "Tovuq tuxum tug'mayapti message",
      title: "Tovuq title",
      phone: "+998943067661",
      address: "Tashkent",
      file: "pdf",
      created_at: "2015"
    },
    {
      message: "Boshqa bir message",
      title: "Boshqa title",
      phone: "+998900000000",
      address: "Samarqand",
      file: "docx",
      created_at: "2015"
    },
  ],
  links: {
    next: "",
    previous: "",
  },
  total_items: 2,
  total_pages: 1,
  page_size: 10,
  current_page: 1,
};





const Reports: FC = () => {
  const intl = useIntl();
  const navigate = useNavigate();

  const dashboardToolbars: Array<PageToolbar> = [
    {
      title: "Shikoyat yo'llash",
      icon: "notepad-edit",
      isActive: true,
      additional: {
        onClick: () => navigate(URL_TEACHER_REPORTS_NEW),
      },
    },
  ];

  return (
    <>
      <PageTitle
        description="Shikoyatlar va ularning natijalari"
        breadcrumbs={reportsBreadCrumbs}
        toolbar={dashboardToolbars}
      />
      <Components.Table
          header={header}
          forPaginationData={teacherReports}
          title="Yuborilgan shikoyatlar"
          body={teacherReports?.results.map((d) => ({
            ...d,
            actions: (
                <div className="d-flex flex-row gap-2">
                  <a href="#" className="btn btn-icon btn-secondary">
                    <KTIcon iconName="eye" className="fs-1"/>
                  </a>
                </div>
            ),
          }))}
          bodyKey={[...bodyKey, "actions"]}
      />
    </>
  );
};

export { Reports };
